export default {
	'total-net': 'Total net',
	'show-all-journal': 'Show all journal',
	'enter-quantity': 'Enter quantity',
	'enter-item-by-barcode': 'Enter item by barcode',
	'paper-document': 'Paper document',
	'addition-item': 'Addition item',
	'the-net-invoice-must-be-zero-and-this-requires-zeroing-all-financial-fields': 'The net invoice must be zero and this requires zeroing all financial fields',

	'confirm-user': 'Confirm user'
}